<template>
  <ModalVue
      :fields="[
      { name: 'firstname', type: 'text', tag: 'input', placeholder: 'imię', value: firstName, req: true, label: 'imię' },
      { name: 'lastname', type: 'text', tag: 'input', placeholder: 'nazwisko', value: lastName, req: true, label: 'nazwisko' },
      { name: 'phone', type: 'tel', tag: 'input', placeholder: 'numer telefonu', req: true, htmlPattern: '[0-9]{9}', value: phone, label: 'numer telefonu' }
    ]"
      title="edytuj dane"
      button-text="zatwierdź"
      :isVisible="isModalVisible"
      @closeModal="() => { isModalVisible = false }"
      @sendData="(data) => editUser(data)"
  />

  <ModalVue
      :fields="[
      { name: 'photo', type: 'file', tag: 'input', req: true }
    ]"
      title="prześlij zdjęcie"
      button-text="wyślij"
      :is-visible="isPhotoModalVisible"
      @closeModal="() => { isPhotoModalVisible = false }"
      @sendData="(data) => sendPhoto(data)"
  />

  <ModalVue
      :fields="[
      { name: 'oldpassword', type: 'password', tag: 'input', req: true, placeholder: 'obecne hasło' },
      { name: 'newpassword', type: 'password', tag: 'input', req: true, placeholder: 'nowe hasło', minlength: 8 },
      { name: 'repeatnewpassword', type: 'password', tag: 'input', req: true, placeholder: 'powtórz nowe hasło', minlength: 8 }
    ]"
      title="zmień hasło"
      :is-visible="isPassModalVisible"
      button-text="zmień"
      @closeModal="() => { isPassModalVisible = false }"
      @sendData="(data) => changePass(data)"
  />

  <ModalVue
      :fields="[
      { name: 'petName', type: 'text', tag: 'input', req: true, placeholder: 'imię zwierzęcia', maxlength: 30 },
      { name: 'photo', type: 'file', tag: 'input', req: true }
    ]"
      title="dodaj zwierzaka"
      button-text="dodaj"
      :is-visible="isPetModalVisible"
      @closeModal="() => { isPetModalVisible = false }"
      @sendData="(data) => addPet(data)"
  />

  <div v-if="currentUser && currentUser.role_id === 3" class="user-data-page">
    <div class="page-header">
      <h1>Twoje dane</h1>
      <div class="header-actions">
        <button class="btn-outline" @click="isModalVisible = true">Edytuj profil</button>
        <button class="btn-primary" @click="isPassModalVisible = true">Zmień hasło</button>
      </div>
    </div>

    <div class="layout">
      <section class="section-card profile-card">
        <div class="profile-top-actions">
          <button class="btn-icon" @click="isModalVisible = true" title="Edytuj">
            <img src="@/assets/icons/pencil-square.svg" alt="edytuj">
          </button>
        </div>

        <button
            class="avatar-btn"
            @click="() => { if (!userPhotoUrl) { isPhotoModalVisible = true } else { removePhoto() } }"
            :title="userPhotoUrl ? 'Usuń zdjęcie' : 'Dodaj zdjęcie'"
        >
          <img class="avatar" :src="userPhotoUrl ? userPhotoUrl : getImageUrl()" alt="">
          <span class="avatar-overlay">
            <img v-if="!userPhotoUrl" src="@/assets/icons/pencil-square.svg" alt="dodaj">
            <img v-else src="@/assets/icons/trash.svg" alt="usuń">
          </span>
        </button>

        <h2 class="profile-name">{{ firstName }} {{ lastName }}</h2>
        <p class="profile-email">{{ email }}</p>

        <div class="info-list">
          <p :class="{ muted: !phone }">{{ phone ? `tel: ${phone}` : 'brak numeru telefonu' }}</p>
          <p class="info-small">Liczba zwierząt: {{ pets.length }}</p>
        </div>

        <div class="card-actions">
          <button class="btn-primary" @click="isPassModalVisible = true">Zmień hasło</button>
          <button class="btn-danger" @click="confirmDelete = true">Usuń konto</button>
        </div>

        <div class="confirm-delete" v-if="confirmDelete">
          <span>Czy na pewno?</span>
          <div>
            <button class="btn-danger" @click="deleteAccount">Tak</button>
            <button class="btn-outline" @click="confirmDelete = false">Nie</button>
          </div>
        </div>
      </section>

      <section class="section-card pets-card">
        <div class="pets-header">
          <h3>Twoje zwierzaki</h3>
          <button class="btn-primary" @click="isPetModalVisible = true">+ Dodaj zwierzaka</button>
        </div>

        <div class="pet-cards-list" v-if="pets.length > 0">
          <article class="pet-card" v-for="pet in pets" :key="pet.id">
            <button class="btn-icon btn-danger soft" @click="removePet(pet.id)" title="Usuń zwierzaka">
              <img src="@/assets/icons/trash.svg" alt="usuń">
            </button>
            <img :src="pet.photo_url ? pet.photo_url : getImageUrl()" alt="">
            <span>{{ pet.pet_name }}</span>
          </article>
        </div>

        <div class="empty-state" v-else>
          <p>Nie masz jeszcze dodanych zwierzaków.</p>
          <button class="btn-outline" @click="isPetModalVisible = true">Dodaj pierwszego</button>
        </div>
      </section>
    </div>
  </div>

  <div v-else class="fallback">
    <h2>Błąd wczytywania. Spróbuj ponownie.</h2>
  </div>
</template>

<script>
import ModalVue from '@/components/Modal.vue';
import authHeader from '@/services/auth-header';
import axios from 'axios';
import { useMeta } from 'vue-meta';
import { useAuthStore } from '@/stores/auth';
import { useAppStore } from '@/stores/app';

export default {
  name: 'PrivProfileUserData',
  components: { ModalVue },
  data() {
    return {
      userPhotoUrl: '',
      userPhotoId: '',
      firstName: '',
      lastName: '',
      email: '',
      pets: [],
      phone: '',
      isModalVisible: false,
      isPhotoModalVisible: false,
      isPassModalVisible: false,
      isPetModalVisible: false,
      confirmDelete: false
    };
  },
  setup() {
    useMeta({ title: 'twoje dane' });

    return {
      authStore: useAuthStore(),
      appStore: useAppStore(),
    };
  },
  computed: {
    currentUser() {
      return this.authStore.user;
    }
  },
  mounted() {
    if (!this.currentUser) {
      this.$router.push('/login');
    } else if (this.currentUser.role_id !== 3) {
      this.$router.push('/login');
    }
    this.getUserData();
  },
  methods: {
    getImageUrl() {
      return new URL(`../../assets/photo-placeholder.png`, import.meta.url).href;
    },
    getUserData() {
      axios.get(`/User/${this.currentUser.id}`).then(res => {
        this.firstName = res.data.firstname;
        this.lastName = res.data.lastname;
        this.email = res.data.email;
        this.pets = res.data.pets;
        this.phone = res.data.phone;
      });

      axios.get(`/UserImage/${this.currentUser.id}`).then(res => {
        if (res.data.length > 0) {
          this.userPhotoUrl = res.data[0].photo_url;
          this.userPhotoId = res.data[0].id;
        }
      });
    },
    editUser(data) {
      axios.post(`/UserProfile`, {
        id: this.currentUser.id,
        name: this.currentUser.name ?? data.firstname + ' ' + data.lastname,
        firstname: data.firstname,
        lastname: data.lastname,
        email: this.email,
        phone: data.phone
      }, authHeader()).then(res => {
        if (String(res.status).charAt(0) == '2') {
          this.appStore.setIsSuccess('Pomyślnie zaktualizowano dane');
          this.firstName = data.firstname;
          this.lastName = data.lastname;
          this.phone = data.phone;
        }
      });
    },
    sendPhoto(data) {
      axios.post('/UserImage', {
        user_id: this.currentUser.id,
        photo: data.photo
      }, {
        headers: {
          ['Content-Type']: 'multipart/form-data'
        }
      }).then(res => {
        if (String(res.status).charAt(0) == '2') {
          this.appStore.setIsSuccess('Pomyślnie dodano zdjęcie');
          this.userPhotoUrl = URL.createObjectURL(data.photo);
        }
      });
    },
    removePhoto() {
      axios.delete(`/UserImage/${this.userPhotoId}`, authHeader).then((res) => {
        if (String(res.status).charAt(0) == '2') {
          this.appStore.setIsSuccess('Pomyślnie usunięto zdjęcie');
          this.userPhotoUrl = '';
        }
      }).catch(() => {
        setTimeout(() => {
          location.reload();
        }, 500);
      });
    },
    changePass(data) {
      axios.post('/ChangePassword', {
        oldpassword: data.oldpassword,
        newpassword: data.newpassword,
        repeatpassword: data.repeatnewpassword
      }, authHeader()).then(res => {
        if (String(res.status).charAt(0) === '2') {
          this.appStore.setIsSuccess('Pomyślnie zaktualizowano hasło');
          window.location.href = '/';
        }
      }).catch(() => {});
    },
    addPet(data) {
      axios.post('/Pet', {
        pet_name: data.petName,
        photo: data.photo
      }, {
        headers: {
          ['Content-Type']: 'multipart/form-data'
        }
      }).then(res => {
        if (String(res.status).charAt(0) == '2') {
          this.appStore.setIsSuccess('Pomyślnie dodano zwierzaka');
          this.pets.push({ pet_name: data.petName, photo_url: URL.createObjectURL(data.photo) });
        }
      });
    },
    removePet(id) {
      axios.delete(`/Pet/${id}`, authHeader()).then(res => {
        if (String(res.status).charAt(0) == '2') {
          this.appStore.setIsSuccess('Pomyślnie usunięto zwierzę');
          this.pets = res.data.data;
        }
      }).catch(() => {});
    },
    deleteAccount() {
      axios.delete(`/User/${this.currentUser.id}`, authHeader()).then(() => {
        this.$router.push('/');
        localStorage.removeItem('userm2VET');
        window.location.reload();
      });
    }
  }
};
</script>

<style scoped lang='scss'>
.user-data-page {
  background: #f9fafb;
  min-height: 100vh;
  padding: 24px 16px 32px;
  color: #1f2937;
  font-family: sans-serif;
}

.page-header {
  max-width: 1200px;
  margin: 0 auto 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
  border-bottom: 2px solid #e5e7eb;
  padding-bottom: 14px;
}

.page-header h1 {
  margin: 0;
  font-size: 2.8rem;
  font-weight: 700;
}

.header-actions {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.layout {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  gap: 20px;
  align-items: flex-start;
  flex-wrap: wrap;
}

.section-card {
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.08);
  padding: 16px;
  box-sizing: border-box;
}

.profile-card {
  width: 320px;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.profile-top-actions {
  display: flex;
  justify-content: flex-end;
}

.avatar-btn {
  border: none;
  background: none;
  cursor: pointer;
  align-self: center;
  width: 120px;
  height: 120px;
  position: relative;
  border-radius: 999px;
  overflow: hidden;
}

.avatar {
  width: 120px;
  height: 120px;
  object-fit: cover;
  border-radius: 999px;
  border: 2px solid #e5e7eb;
}

.avatar-overlay {
  position: absolute;
  inset: 0;
  background: rgba(17, 24, 39, 0.35);
  opacity: 0;
  transition: 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;
}

.avatar-overlay img {
  width: 20px;
  height: 20px;
}

.avatar-btn:hover .avatar-overlay {
  opacity: 1;
}

.profile-name {
  margin: 6px 0 0;
  text-align: center;
  font-size: 1.9rem;
}

.profile-email {
  margin: 0;
  text-align: center;
  color: #6b7280;
}

.info-list {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.info-list p {
  margin: 0;
  font-size: 1.4rem;
  color: #374151;
  text-align: center;
}

.info-list p.muted {
  color: #9ca3af;
}

.info-small {
  color: #6b7280 !important;
}

.card-actions {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 8px;
}

.confirm-delete {
  margin-top: 8px;
  background: #fff1f2;
  border: 1px solid #fecdd3;
  border-radius: 8px;
  padding: 10px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: center;
}

.confirm-delete div {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  justify-content: center;
}

.pets-card {
  flex: 1 1 0;
  min-width: 0;
}

.pets-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  margin-bottom: 12px;
}

.pets-header h3 {
  margin: 0;
  font-size: 1.9rem;
}

.pet-cards-list {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}

.pet-card {
  width: 180px;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  padding: 10px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: center;
  position: relative;
  transition: box-shadow .2s, border-color .2s;
}

.pet-card:hover {
  border-color: #10b981;
  box-shadow: 0 4px 14px rgba(0,0,0,0.08);
}

.pet-card img {
  width: 92px;
  height: 92px;
  object-fit: cover;
  border-radius: 50%;
}

.pet-card span {
  font-size: 1.4rem;
  font-weight: 600;
  text-align: center;
  color: #1f2937;
}

.pet-card .btn-icon.soft {
  position: absolute;
  top: 6px;
  right: 6px;
}

.empty-state {
  text-align: center;
  color: #9ca3af;
  border: 1px dashed #d1d5db;
  border-radius: 10px;
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: center;
}

.btn-primary,
.btn-outline,
.btn-danger,
.btn-icon {
  border-radius: 8px;
  font-size: 1.35rem;
  cursor: pointer;
}

.btn-primary {
  background: #f97316;
  color: #fff;
  border: none;
  padding: 10px 14px;
  font-weight: 600;
}
.btn-primary:hover { background: #ea6c0a; }

.btn-outline {
  background: #fff;
  color: #1f2937;
  border: 1px solid #d1d5db;
  padding: 10px 14px;
}
.btn-outline:hover {
  border-color: #10b981;
  color: #10b981;
}

.btn-danger {
  background: #dc3545;
  color: #fff;
  border: none;
  padding: 10px 14px;
}
.btn-danger:hover { background: #b91c1c; }

.btn-icon {
  background: none;
  border: none;
  padding: 6px;
}
.btn-icon img {
  width: 18px;
  height: 18px;
}

.fallback {
  padding: 24px;
  text-align: center;
}

@media (max-width: 980px) {
  .layout {
    flex-direction: column;
  }

  .profile-card {
    width: 100%;
  }

  .pets-header .btn-primary {
    width: auto;
  }
}

@media (max-width: 480px) {
  .user-data-page {
    padding: 16px 12px 24px;
  }

  .page-header h1 {
    font-size: 2.2rem;
  }

  .btn-primary,
  .btn-outline,
  .btn-danger {
    width: 100%;
    text-align: center;
  }

  .pet-card {
    width: 100%;
  }

  .confirm-delete div {
    width: 100%;
  }

  .confirm-delete div button {
    flex: 1;
  }
}
</style>